import React from 'react'

const SharedSummary = ({ groupTripInfo }) => {
  const { subtotal, total, promoMessaging, promotionalDiscount } =
    groupTripInfo.cart

  /*
  NOTE this is a different formatter than the one
  in the helpers file.  This one does NOT strip out .00
 */
  let USDollarFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  })

  return (
    <div
      data-testid="gpp-sidebar-order-summary"
      className="gpp-sidebar-order-summary"
    >
      <h2 className="order-summary"> Order summary </h2>

      <dl data-testid="order-summary">
        <dt className="gpp-sidebar-divider">Order Subtotal</dt>
        <dd
          className="gpp-sidebar-divider"
          data-testid="gpp-order-subtotal"
        >
          ${subtotal.toFixed(2)}
        </dd>

        {promotionalDiscount < 0 && (
          <>
            <dt className="gpp-sidebar-divider">Discount Applied*</dt>
            <dd
              className="gpp-sidebar-divider"
              data-testid="gpp-promo-discount"
            >
              {USDollarFormatter.format(promotionalDiscount)}
            </dd>
          </>
        )}

        <dt className="font-bold">Order Total</dt>
        <dd
          className="font-bold"
          data-testid="gpp-order-total"
        >
          ${total.toFixed(2)}
        </dd>
      </dl>

      {promoMessaging && (
        <div
          className="gpp-promo-messaging"
          data-testid="gpp-promo-messaging"
        >
          *{promoMessaging}
        </div>
      )}
    </div>
  )
}

export default SharedSummary
